import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { SeasonPoolTransformed } from "~pages/SeasonPools/types/seasonPoolTransformed.ts";
import { transformSeasonPool } from "~pages/SeasonPools/utilities/transformSeasonPool.ts";
import type { PoolResponse } from "~types/pool.ts";

export const useGetSeasonPool = () => {
  const request = useApi();
  const { organizationId, sport, seasonId = "", poolCode } = useParams();

  return useQuery<SeasonPoolTransformed>({
    queryKey: ["seasonPool", sport, organizationId, seasonId, poolCode],
    enabled: !!poolCode,
    queryFn: () =>
      request<PoolResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/pools/${poolCode}?include=seasonStages`).then((response) => {
        const item = response?.data?.[0];
        if (!item) {
          throw new Error("Season pool not found");
        }

        return transformSeasonPool(item, response?.includes?.resources, seasonId);
      }),
  });
};
